import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import CardLiveStreamBig from 'components/CardLiveStreamBig'
import Layout from 'components/Layout'
import { getStationsWithEPGData } from 'lib/epg-data'
import { caching } from 'lib/utils'
import Head from 'next/head'
import React, { useState } from 'react'
import { Navigation, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

const useStyles = makeStyles((theme) => ({
  header: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  swiper: {
    marginBottom: theme.spacing(7)
  },
  swiperSlide: {
    width: '340px',
    marginRight: theme.spacing(0.5)
  }
}))

export default function SwiperLiveTV ({ stations }) {
  const classes = useStyles()
  const [activeSlide, setActiveSlide] = useState(null)

  const active = (index) => {
    if (!activeSlide && index === 0) {
      // fix for Chrome on page reload / drirect page access
      return true
    } else if (activeSlide) {
      return index === activeSlide
    } else {
      return false
    }
  }

  return (
    <>
      <Head>
        <title>Sendung verpasst? Live TV</title>
        <meta name='description' content='Livestream aller Sender jederzeit kostenlos abrufen: ARD, ZDF, RTL, Arte, 3Sat, Pro7 etc.' />
      </Head>
      <Layout header={
        <div className={classes.header}>
          <Typography variant='h1' component='h1'>Live TV</Typography>
        </div>
      }
      >
        <Swiper
          modules={[Navigation, A11y]}
          navigation
          slidesPerView='auto'
          lazyPreloadPrevNext={3}
          watchOverflow
          className={classes.swiper}
          centeredSlides
          loop
          onSwiper={(swiper) => setActiveSlide(swiper.realIndex)}
          onSlideChange={(swiper) => setActiveSlide(swiper.realIndex)}
          breakpoints={{
            740: {
              lazy: { loadPrevNextAmount: 4 }
            },
            1090: {
              lazy: { loadPrevNextAmount: 6 }
            }
          }}
        >
          {stations.map((station, index) => (
            <SwiperSlide key={station.slug} className={classes.swiperSlide}>
              <CardLiveStreamBig station={station} active={active(index)} width={340} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Layout>
    </>
  )
}

export async function getServerSideProps (context) {
  caching(context.res, process.env.CACHE_STATION)

  const stations = await getStationsWithEPGData()

  return {
    props: {
      stations
    }
  }
}
